import { APIsRoutes } from "@/domain/Integrations/APIs/presentation/routes/apis.routes";
import { WebServicesRoutes } from "@/domain/Integrations/WebServices/presentation/routes/webservices.routes";

export const IntegrationsRoutes = [
  {
    path: "integrations",
    name: "integrations",
    redirect: { name: "listApis" },
    meta: { requiresAuth: true, permissions: "integrations.read" },
  },
  ...APIsRoutes,
  ...WebServicesRoutes,
];
